module.exports = __webpack_public_path__ + "img/checkout_complete.ecc8b091.svg";